<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester semester-nonall ssystem college department sclass keyword="學號、學生姓名">
                </query>
                <btn-group :load="reload" :input="input"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th>學號-學生姓名</th>
                            <th>最後發放日期</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.ScholarshipID">
                        <td data-th="學號-學生姓名"><b-button size="sm" variant="link" @click="edit(item.ScholarshipID)">{{item.StudentNo}}-{{item.StudentName}}</b-button></td>
                        <td data-th="證照補助">{{item.Last|date('yyyy/mm/dd')}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload">
        </Detail>
        <inputmodal id="input" sample="/template/license.xlsx" url="/api/scholarshipdetail/excel?Type=License" @ok="reload()"></inputmodal>
    </page-main>
</template>

<script>
    import Detail from './licenseDetail.vue';

    import { master } from '@/views';
    export default master({
        name: 'license',
        api: '/api/ScholarshipDetail/',
        components: { Detail },
        query: { Type: "License" }
    });
</script>

<style>
</style>